var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"geolocation-navbar"},[_c('c-button',{attrs:{"size":"lg","icon":"map-marker"}},[(_vm.showText)?_c('span',[_vm._v("Próximas a você")]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/poi/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-394397ca","hasScoped":true,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/poi/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/Navbar/GeolocationNavbar.vue
// module id = 2090
// module chunks = 1612